module.exports = __webpack_public_path__ + "img/_logo-american-express.6634a498.svg";